/**
 * @license
 * Copyright Google Inc. All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.io/license
 */

import {__core_private__ as r} from '@angular/core';

export const /** @type {?} */ isPromise: typeof r.isPromise = r.isPromise;
export const /** @type {?} */ isObservable: typeof r.isObservable = r.isObservable;

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
